import {
  TextInput,
  Grid,
  Stack,
  ScrollArea,
  Button,
  LoadingOverlay,
  CloseButton,
  Group,
} from "@mantine/core";
import React from "react";
import { useMutation } from "@apollo/client";
import { showNotification } from "@mantine/notifications";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { CREATE_Value } from "apollo/mutuations";
import { FiEdit, FiEye, FiPlus } from "react-icons/fi";
import { customLoader } from "components/utilities/loader";
import Controls from "components/controls/Controls";

const AddValueModal = ({ id, setOpened, activePage, refetch }) => {
  const form = useForm({
    initialValues: {
      value: "", // single input
      values: [], // array to send
    },
  });

  const { height } = useViewportSize();

  const [addValue, { loading: addValues }] = useMutation(CREATE_Value);

  const handleAddValue = () => {
    const input = form.values.value.trim();
    if (!input) return;

    if (!form.values.values.includes(input)) {
      form.setFieldValue("values", [...form.values.values, input]);
    }
    form.setFieldValue("value", "");
  };

  const handleRemoveValue = (valToRemove) => {
    const filtered = form.values.values.filter((val) => val !== valToRemove);
    form.setFieldValue("values", filtered);
  };

  const submit = () => {
    if (form.validate().hasErrors) return;

    if (form.values.values.length === 0) {
      showNotification({
        color: "red",
        title: "Error",
        message: "Please add at least one value before submitting.",
      });
      return;
    }
    let variables = {
      id: id,
      values: form.values.values,
    };
    console.log(variables);
    addValue({
      variables: {
        id: id,
        values: form.values.values,
      },
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Values Created Successfully",
        });
        setOpened(false);
        refetch();
      },
      onError(error) {
        const errorMessage =
        error?.graphQLErrors?.[0]?.message ||
        "Values Not Created Successfully!";

        showNotification({
          color: "red",
          title: "Error",
          message: errorMessage,
        });
      },
    });
  };

  return (
    <>
      <LoadingOverlay
        visible={addValues}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={8}>
                <TextInput
                  label="Value"
                  placeholder="Enter a value and click Add"
                  {...form.getInputProps("value")}
                />
              </Grid.Col>

              <Grid.Col span={3} mt={22}>
                <Controls.ActionButton
                  color="primary"
                  title="Add Values"
                  onClick={handleAddValue}
                >
                  <FiPlus fontSize="medium" />
                </Controls.ActionButton>
              </Grid.Col>

              <Grid.Col span={12}>
                <Stack spacing="xs">
                  {form.values.values.map((val, idx) => (
                    <Group
                      key={idx}
                      spacing="xs"
                      style={{
                        background: "#f1f3f5",
                        padding: "8px 12px",
                        borderRadius: 6,
                        justifyContent: "space-between",
                      }}
                    >
                      <span>{val}</span>
                      <CloseButton
                        size="sm"
                        onClick={() => handleRemoveValue(val)}
                        aria-label="Remove value"
                      />
                    </Group>
                  ))}
                </Stack>
              </Grid.Col>

              <Grid.Col span={12}>
                <Button
                  style={{
                    width: "30%",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  fullWidth
                  type="submit"
                  color="blue"
                >
                  Submit
                </Button>
              </Grid.Col>
            </Grid>
          </Stack>
        </form>
      </ScrollArea>
    </>
  );
};

export default AddValueModal;
